import React from "react";
import "./categoryMenu.css";

import TestImage from "../../../../images/icons/milkshake.png";

import CarouselSlider from "../Carousel/CarouselSlider";

export default function CategoryMenu(props) {
  const categorieElements = props.data.map((val) => {
    return (
      <div
        className={`category-list-item 
                    ${val.categoryTitle === props.active ? "item-active" : ""}`}
        key={val.categoryTitle}
        onClick={() => props.setActive(val.categoryTitle)}
      >
        <img src={val.categoryPicture} alt="" />
        {val.categoryTitle}
      </div>
    );
  });

  return (
    <div className="category-list">
      <CarouselSlider
        fixedWidth={false}
        gap="3px"
        arrowGap="10px"
        stepless={true}
      >
        {categorieElements}
      </CarouselSlider>
    </div>
  );
}
